import React, { Component } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
	backgroundColor: "orange",
	paddingTop: "30vh",
	paddingLeft: theme.spacing(1),
	paddingRight: theme.spacing(1),
	minHeight: "100vh"
}));

class NoMatch extends Component {
	render() {
		return (
			<StyledPaper>
				<Grid container direction="column" alignItems="center" spacing={2}>
					<Grid item>
						<Typography variant="h4">Whoops!</Typography>
					</Grid>
					<Grid item>
						<Typography variant="subtitle1">Nothing to see; nothing to say.</Typography>
					</Grid>
					<Grid item>
						<Link className="primary" to="/">
							<Button
								color="primary"
								ga-on="click"
								ga-event-category="WebApp"
								ga-event-action="Button Pressed"
								ga-event-label="Restart">
								Restart
							</Button>
						</Link>
					</Grid>
					<Grid item>
						<Typography variant="caption">
							This site is protected by reCAPTCHA and the Google{' '}
							<a href="https://policies.google.com/privacy">Privacy Policy</a>{' '}
							and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
						</Typography>
					</Grid>
				</Grid>
			</StyledPaper>
		);
	}
}

NoMatch.propTypes = {};

export default NoMatch;